import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Message } from 'src/app/core/class/message';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { WarningSessionTimeoutComponent } from '../warning-session-timeout/warning-session-timeout.component';

@Component({
  selector: 'app-warning-has-token',
  templateUrl: './warning-has-token.component.html',
  styleUrls: ['./warning-has-token.component.scss']
})
export class WarningHasTokenComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    public message: Message,
    public dialogRef: MatDialogRef<WarningHasTokenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string[],
  ) { }

  ngOnInit() {
  }

  onNoClick(){
    this.dialogRef.close()
  }

  onLogoutClick(){
    localStorage.removeItem('userLogedIn');
    localStorage.removeItem('userOnUnload');
    this.dialogRef.close()
  }

}
